import { render } from "./SchedulePage.vue?vue&type=template&id=2878ccdb"
import script from "./SchedulePage.vue?vue&type=script&lang=js"
export * from "./SchedulePage.vue?vue&type=script&lang=js"

import exportComponent from "/home/gbl/SoftwareProjects/MyProjects/UniStuttgart/truscanWebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__